<template>
  <div id="contenedor-perfil-usuario-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'PerfilUsuarioMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
